export default function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    function whatStepCanBeSkipped(claim) {
        return claim.policy && claim.lossCause && claim.lossDate;
    }

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.wc.config.FlowConfig.Error creating claim',
                message: 'fnol.wc.config.FlowConfig.An error occurred attempting to create a claim.'
            },
            progress: {
                message: 'fnol.wc.config.FlowConfig.Creating draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(model) {
            if (model.claimNumber.value) {
                return $q.resolve(model);
            }
            return LoadSaveService.createClaim(model.value);
        }
    };

    return function (step, junction) {
        junction('wcSuccess');

        junction('wcError');

        step('wcWhat', true).onNext.doAction(function (model) {
            return ACTIONS.createClaim(model);
        }, ACTION_MSG.createClaim).thenBranch(function () {
            return 'wcInjury';
        }, function () {
            return 'wcError';
        }).skipOnResumeIf(whatStepCanBeSkipped).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.wc.What');
        });

        step('wcInjury').onNext.goTo('wcWhere').skipOnResumeIf(function (_ref) {
            var claim = _ref.value;
            return claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.wc.Injury');
        });

        step('wcWhere').onNext.goTo('wcSuccess').skipOnResumeIf(function (_ref2) {
            var claim = _ref2.value;
            return claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.wc.Where');
        });
    };
}